import React from 'react';
import { getBwjSpinnerStyles } from './styles';

interface IBwjSpinnerProps {
  size?: string | number;
}

export const BwjSpinner: React.FunctionComponent<IBwjSpinnerProps> = (props) => {
  const styles = getBwjSpinnerStyles(props.size);

  return (
    <div className={styles.spinner} />
  );
};
